module.exports = __webpack_public_path__ + "img/SEARCH.994eaa35.svg";